import { render } from "./AboutView.vue?vue&type=template&id=07b211b4"
import script from "@/assets/js/about.js?vue&type=script&lang=js&external"
export * from "@/assets/js/about.js?vue&type=script&lang=js&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__